import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  container: { background: "#13082A", color: "white" },
  heading: {
    fontSize: "40px !important",
    fontWeight: 700 + "!important",
  },
}));
